import { Button, Modal } from "@mantine/core";
import { useParams } from "react-router";
import { ModalFooter } from "../../mantine/components/ModalFooter/ModalFooter";
import {
  groupMissingData,
  renderGroupedMissingData
} from "./OnboardingWizard/OnboardingMailPage/OnboardingMailPage";
import type {
  OperatorChange,
  OperatorChangeSteps
} from "./OperatorChanges/OperatorChanges.types";
import type {
  TenantChange,
  TenantChangeSteps
} from "./TenantChanges/TenantChanges.types";

type ChangeProcess = OperatorChange | TenantChange;

type ChangeProcessModalProps = {
  changeProcesses: Array<ChangeProcess>;
  step: keyof OperatorChangeSteps | keyof TenantChangeSteps;
  onClose: () => void;
  isOpen: boolean;
  projectId: string;
};

function ChangeProcessModal({
  changeProcesses,
  projectId,
  step,
  onClose,
  isOpen
}: ChangeProcessModalProps) {
  const { processId } = useParams();
  const process = changeProcesses.find(
    (process) => process.id === parseInt(processId ?? "-1", 10)
  );
  const processStep = process?.steps[step];
  const missingData = processStep?.missingData || [];
  const groupedMissingData = groupMissingData(missingData);

  return (
    <Modal opened={isOpen} title="Fehlende Daten ergänzen" onClose={onClose}>
      {renderGroupedMissingData({
        projectId,
        groupedData: groupedMissingData
      })}
      <ModalFooter>
        <Button onClick={onClose}>Fertig</Button>
      </ModalFooter>
    </Modal>
  );
}

export { ChangeProcessModal };
